/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { CashBoxesStatisticsDto } from '../api/statistics/statisticsClient.typings';

export enum StatisticsActionType {
    OPEN_STATISTICS_PAGE = 'Statistics/ open page',
    EXIT_STATISTICS_PAGE = 'Statistics/ exit page',

    FETCH_CASHBOX_STATISTICS = 'Statistics/ fetch cashbox statistics (state) start',
    FETCH_CASHBOX_STATISTICS_SUCCESS = 'Statistics/ fetch cashbox statistics (state) success',
    FETCH_CASHBOX_STATISTICS_ERROR = 'Statistics/ fetch cashbox statistics (state) error',
}

export const openStatisticsPageAction = () => createAction(StatisticsActionType.OPEN_STATISTICS_PAGE);

export const exitStatisticsPageAction = () => createAction(StatisticsActionType.EXIT_STATISTICS_PAGE);

export const fetchCashboxStatisticsAction = () => createAction(StatisticsActionType.FETCH_CASHBOX_STATISTICS);

export const fetchCashboxStatisticsSuccessAction = (payload: CashBoxesStatisticsDto) =>
    createAction(StatisticsActionType.FETCH_CASHBOX_STATISTICS_SUCCESS, payload);

export const fetchCashboxStatisticsErrorAction = (notification: Notification) =>
    createAction(StatisticsActionType.FETCH_CASHBOX_STATISTICS_ERROR, { notification });

export type StatisticsActions =
    | ReturnType<typeof openStatisticsPageAction>
    | ReturnType<typeof exitStatisticsPageAction>
    | ReturnType<typeof fetchCashboxStatisticsAction>
    | ReturnType<typeof fetchCashboxStatisticsSuccessAction>
    | ReturnType<typeof fetchCashboxStatisticsErrorAction>;
